import { useMemo } from 'react';

import { PlaybackEngine } from './playbackEngine.types';

const EMPTY_DENSITY: number[] = [];

export const useWaveSurferEngine = (): PlaybackEngine =>
  useMemo(
    () => ({
      type: 'wavesurfer' as const,
      play: async () => {
        window.player?.play();
      },
      pause: () => {
        window.player?.pause();
      },
      stop: () => {
        window.player?.stop();
      },
      seekTo: (progress: number) => {
        window.player?.seekTo(progress);
      },
      getDuration: () => window.player?.getDuration() || 0,
      getCurrentTime: () => window.player?.getCurrentTime() || 0,
      getNoteDensity: () => EMPTY_DENSITY,
    }),
    []
  );
